import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=007c4216"
import script from "./tip.vue?vue&type=script&lang=js"
export * from "./tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports